import { render, staticRenderFns } from "./AnnouncementPageV2.vue?vue&type=template&id=6cbae325&scoped=true&lang=pug"
import script from "./AnnouncementPageV2.vue?vue&type=script&lang=js"
export * from "./AnnouncementPageV2.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementPageV2.vue?vue&type=style&index=0&id=6cbae325&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbae325",
  null
  
)

export default component.exports